import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';
import { getTranslation } from '../../../utils/translations';

const ServiceModal = ({ service, onClose, onSave, language }) => {
  const t = getTranslation(language);
  const [formData, setFormData] = useState({
    serviceName: '',
    serviceCode: '',
    category: 'orthodontics',
    description: '',
    unitPrice: '',
    isActive: true
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (service) {
      setFormData({
        serviceName: service?.serviceName || '',
        serviceCode: service?.serviceCode || '',
        category: service?.category || 'orthodontics',
        description: service?.description || '',
        unitPrice: service?.unitPrice?.toString() || '',
        isActive: service?.isActive !== undefined ? service?.isActive : true
      });
    }
  }, [service]);

  const categoryOptions = [
    { value: 'Orthodontie', label: 'Orthodontie' },
    { value: 'Aligneurs', label: 'Aligneurs' },
    { value: 'Consultation', label: 'Consultation' },
    { value: 'Imagerie', label: 'Imagerie' },
    { value: 'Traitement', label: 'Traitement' },
    { value: 'Maintenance', label: 'Maintenance' },
    { value: 'Production', label: 'Production' },
    { value: 'Logistique', label: 'Logistique' },
    { value: 'Autre', label: 'Autre' },
  ];

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);

    try {
      const data = {
        serviceName: formData?.serviceName,
        serviceCode: formData?.serviceCode,
        category: formData?.category,
        description: formData?.description,
        unitPrice: parseFloat(formData?.unitPrice),
        isActive: formData?.isActive
      };

      if (service) {
        await onSave(service?.id, data);
      } else {
        await onSave(data);
      }
    } catch (error) {
      console.error('Error saving service:', error);
      alert(language === 'FR' ? 'Erreur lors de l\'enregistrement' : 'Error saving service');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 animate-fade-in">
      <div className="bg-card border border-border rounded-lg shadow-modal w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-border sticky top-0 bg-card">
          <h2 className="text-xl font-semibold text-foreground">
            {service ? 'Modifier le Service' : 'Nouveau Service'}
          </h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-muted transition-colors">
            <Icon name="X" size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Nom du Service"
              value={formData?.serviceName}
              onChange={(e) => setFormData({ ...formData, serviceName: e?.target?.value })}
              placeholder="Ex: Aligneurs Invisibles"
              required
            />

            <Input
              label="Code du Service"
              value={formData?.serviceCode}
              onChange={(e) => setFormData({ ...formData, serviceCode: e?.target?.value?.toUpperCase() })}
              placeholder="Ex: SRV-001"
              required
            />
          </div>

         <Select
  label="Catégorie"
  value={formData?.category}
  onChange={(value) => setFormData({ ...formData, category: value })} // ← Changé ici
  options={categoryOptions}
  required
/>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Description
            </label>
            <textarea
              value={formData?.description}
              onChange={(e) => setFormData({ ...formData, description: e?.target?.value })}
              placeholder="Description détaillée du service..."
              rows={4}
              className="w-full px-4 py-2 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary resize-none"
            />
          </div>

          <Input
            label="Prix Unitaire"
            type="number"
            min="0"
            step="0.01"
            value={formData?.unitPrice}
            onChange={(e) => setFormData({ ...formData, unitPrice: e?.target?.value })}
            placeholder="0.00"
            required
          />

          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              id="isActive"
              checked={formData?.isActive}
              onChange={(e) => setFormData({ ...formData, isActive: e?.target?.checked })}
              className="w-4 h-4 rounded border-border text-primary focus:ring-primary"
            />
            <label htmlFor="isActive" className="text-sm font-medium text-foreground">
              Service actif
            </label>
          </div>

          <div className="flex items-center gap-3 pt-4 border-t border-border">
            <Button type="submit" fullWidth loading={loading}>
              {service ? 'Mettre à jour' : 'Créer le Service'}
            </Button>
            <Button type="button" variant="outline" fullWidth onClick={onClose}>
              Annuler
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ServiceModal;